import './components.scss';

const NavigationHeaderItem = (props) => {
  return (
    <div className='navigationHeaderLinkButton'>
      <p>{props.name}</p>
    </div>
  )
}

export default NavigationHeaderItem;